import { ofType } from 'redux-observable';
import { interval } from 'rxjs';
import {
	switchMap,
	map,
	mergeMap,
	takeUntil,
	catchError,
} from 'rxjs/operators';
import { catchErrorForEpics } from '../../../../lib/epic-utils';
import { rxjsApiFetcher, rxjsApiFetcherWithoutAuthorization } from '../../../lib/general-utils';
import {
	actionTypes,
	authActions,
	platformSettingActions,
	applicationActions,
	notifyActions,
	meActions,
	languageActions,
} from '../../../controller';

const {
	START_ID_LOGIN,
	START_ANONYMOUS_LOGIN,
	START_CHECK_AUTH,
	START_FETCH_ME,
	START_HEARTBEAT,
	STOP_HEARTBEAT,
	START_UPDATE_ME_LANGUAGE_CODE,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	idLoginSuccessAction,
	idLoginFailedAction,
	anonymousLoginSuccessAction,
	anonymousLoginFailedAction,
	checkAuthAction,
	checkAuthSuccessAction,
	checkAuthFailedAction,
	setJWTAction,
	updateMeLanguageCodeSuccessAction,
	updateMeLanguageCodeFailedAction,
} = authActions;
const {
	fetchMeSuccessAction,
	fetchMeFailedAction,
	startHeartbeatAction,
} = meActions;
const {
	fetchPlatformSettingAction,
} = platformSettingActions;
const {
	forceConnectSocketAction,
} = applicationActions;
const {
	setLanguage,
} = languageActions;

export function idLoginEpic(action$) {
	return action$.pipe(
		ofType(START_ID_LOGIN),
		switchMap(({ clientId, code, source }) =>
			rxjsApiFetcherWithoutAuthorization
				.post('loginViaId', { clientId, code, source })
				.pipe(
					map(payload => payload.response),
					mergeMap(({ jwt }) => {
						return [
							setJWTAction(jwt),
							idLoginSuccessAction(),
							fetchPlatformSettingAction(),
						];
					}),
					catchError(error => catchErrorForEpics(error, idLoginFailedAction, notifyErrorAction)),
				),
		),
	);
}

export function anonymousLoginEpic(action$) {
	return action$.pipe(
		ofType(START_ANONYMOUS_LOGIN),
		switchMap(({ clientLoginCode }) =>
			rxjsApiFetcherWithoutAuthorization
				.post('auth/anonymous', { clientLoginCode })
				.pipe(
					map(payload => payload.response),
					mergeMap(({ jwt }) => {
						return [
							anonymousLoginSuccessAction(),
							setJWTAction(jwt),
							checkAuthAction(),
							fetchPlatformSettingAction(),
						];
					}),
					catchError(error => catchErrorForEpics(error, anonymousLoginFailedAction, notifyErrorAction)),
				),
		),
	);
}

export function checkAuthEpic(action$) {
	return action$.pipe(
		ofType(START_CHECK_AUTH),
		switchMap(() => rxjsApiFetcher.get('users/id=me')
			.pipe(
				map(payload => payload.response),
				mergeMap(me => {
					return [
						checkAuthSuccessAction(me),
						fetchPlatformSettingAction(),
						forceConnectSocketAction(),
						startHeartbeatAction(),
					];
				}),
				catchError(error => catchErrorForEpics(error, checkAuthFailedAction)),
			),
		),
	);
}

export function fetchMeEpic(action$) {
	return action$.pipe(
		ofType(START_FETCH_ME),
		switchMap(() => rxjsApiFetcher
			.get('users/id=me')
			.pipe(
				map(payload => payload.response),
				map(me => fetchMeSuccessAction(me)),
				catchError(error => catchErrorForEpics(error, fetchMeFailedAction, notifyErrorAction)),
			),
		),
	);
}

const LATENCY = 1000 * 60;

export function heartbeatEpic(action$) {
	return action$.pipe(
		ofType(START_HEARTBEAT),
		switchMap(() =>
			interval(LATENCY).pipe(
				takeUntil(action$.pipe(ofType(STOP_HEARTBEAT))),
				mergeMap(() => rxjsApiFetcher
					.get('users/id=me')
					.pipe(
						map(payload => payload.response),
						map((me = {}) => fetchMeSuccessAction(me)),
						catchError(error => catchErrorForEpics(error, fetchMeFailedAction, notifyErrorAction)),
					),
				),
			),
		),
	);
}

// PUT  /api/v1/users/id=me/language-code
// https://app.gitbook.com/o/-LSmguN2bxAKDgeXkorc/s/-MF-7vQ7EQDyWfUwVpw4/cs-spec.-v2.0/client-ke-hu-duan/888.012-user
export function updateMeLanguageEpic(action$) {
	return action$.pipe(
		ofType(START_UPDATE_ME_LANGUAGE_CODE),
		switchMap(({ languageCode }) => rxjsApiFetcher
			.put('users/id=me/language-code', { languageCode })
			.pipe(
				map(payload => payload.response),
				mergeMap(() => {
					return [
						setLanguage(languageCode),
						updateMeLanguageCodeSuccessAction(),
					];
				}),
				catchError(error => catchErrorForEpics(error, updateMeLanguageCodeFailedAction, notifyErrorAction)),
			),
		),
	);
}
